export default __webpack_public_path__ + "static/media/streaks 100.2fd4252a.svg";